/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable react/display-name */
import React from "react";

interface SingleSelectableProps {
    checked?: boolean;
    onCheckedChange?: (val: boolean) => void;
    identifier?: any;
}

interface State {}

export interface SingleSelectProps {
    selection?: any[];
    onSelectionChanged: (selection: any[]) => void;
}

export function singleSelectable<T extends SingleSelectableProps>(
    Component: React.ComponentType<T>
) {
    

    type OwnProps = SingleSelectProps & T; //Props that are allowed to passed from Resulting component returned from HOC.
    type HOCProps = OwnProps;

    return class extends React.PureComponent<HOCProps, State> {
        constructor(props: HOCProps) {
            super(props);
            this.state = {};
        }

        render() {
            const {
                selection = [],
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onSelectionChanged = () => {},
                identifier,
                onCheckedChange,
                ...rest
            } = this.props;
            const tsBypass: T = rest as any;
            let checked = rest.checked;
            checked =
                this.props.selection.findIndex(a => a === identifier) >= 0;
            return (
                <Component
                    {...tsBypass}
                    checked={checked}
                    identifier={identifier}
                    onCheckedChange={val => {
                        if (val) {
                            onSelectionChanged([...selection, identifier]);
                        } else {
                            onSelectionChanged(
                                selection.filter(a => a !== identifier)
                            );
                        }
                    }}
                />
            );
        }
    };
}

export default singleSelectable;
